import { useEffect } from 'react'
import { PreferredGenresSettings } from './PreferredGenresSettings'

interface PreferredGenresModalProps {
  isOpen: boolean
  onClose: () => void
  showSuggestions?: boolean
}

export function PreferredGenresModal({
  isOpen,
  onClose,
  showSuggestions = true,
}: PreferredGenresModalProps) {
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
      return () => {
        document.removeEventListener('keydown', handleEscape)
        document.body.style.overflow = 'unset'
      }
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-2 lg:p-4">
      {/* Backdrop */}
      <button
        type="button"
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
        aria-label="Close modal"
      />

      {/* Modal */}
      <div className="relative w-full max-w-4xl max-h-[95vh] lg:max-h-[90vh] overflow-hidden rounded-lg lg:rounded-2xl bg-card shadow-2xl animate-in fade-in-0 zoom-in-95 duration-200">
        {/* Close button */}
        <button
          type="button"
          className="absolute top-3 right-3 lg:top-4 lg:right-4 z-10 rounded-md p-2 text-muted-foreground hover:text-foreground hover:bg-muted focus:outline-none focus:ring-2 focus:ring-primary touch-manipulation"
          onClick={onClose}
        >
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Settings component */}
        <div className="overflow-y-auto max-h-[95vh] lg:max-h-[90vh]">
          <PreferredGenresSettings
            onClose={onClose}
            showSuggestions={showSuggestions}
            isModal={true}
          />
        </div>
      </div>
    </div>
  )
}
